import { render } from "./BaseTable.vue?vue&type=template&id=17a745ea&scoped=true"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"

import "./BaseTable.vue?vue&type=style&index=0&id=17a745ea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a745ea"]])

export default __exports__